import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
export default function useDayjs() {
  dayjs.extend(utc);
  dayjs.extend(tz);
  const userTimeZone = dayjs.tz.guess();
  return {
    dayjs,
    userTimeZone,
  };
}
